import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {NormalFilterControl} from '../../../interface/normal-filter-control';
import {isPlatformBrowser, Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';

@Component({
	selector: 'fb-normal-filter-config',
	templateUrl: './normal-filter-config.component.html',
	styleUrls: ['./normal-filter-config.component.scss']
})
export class NormalFilterConfigComponent {
	@Input() public control: NormalFilterControl = {} as NormalFilterControl;
	@Output() public onControlChange: EventEmitter<null> = new EventEmitter<null>();

	public collapse: boolean = true;
	public isSearchPage = false;
	public isBrowser: boolean = false;

	constructor(
		private _location: Location,
		private _activatedRoute: ActivatedRoute,
		@Inject(PLATFORM_ID) private _platformId: Object
		) {
			this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public toggleCollapse(): void {
		this.collapse = !this.collapse;
	}
	public route = '';
	public onChange(): void {

		let currentRoute = '';
		if (this.isBrowser) {
			currentRoute = window.location.href;

			this.route = currentRoute;
			this.onControlChange.emit(null);
		}
	}

	public updateUrl(url: string): void {
		this._location.go(url)
	}

	public ngOnInit(): void {

	}
}
